<template>
  <v-container class="pl-0 pb-0">
    <v-row v-if="agency" no-gutters>
      <span style="color: #004C97; font-weight: bold; display: inline-block">{{ agency.name }}</span>
      <span style="margin-left: 10px; display: inline-block; font-size: .8em;">Customer ID: {{ agency.agencyId }}</span>
    </v-row>
    <v-row style="color: #A5814b; font-weight: bold;" class="pt-2" no-gutters>
      <v-col cols="auto">{{ product.name }}</v-col>
      <v-col v-if="productDescription.length > 0" cols="auto" class="pl-0">{{ productDescription }}</v-col>
    </v-row>
    <v-row style="color: #A5814b; font-weight: bold;" class="pl-1 title">{{ title }}</v-row>
  </v-container>

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import productIdMappingMixin from '@/mixins/productIdMappingMixin';

export default {
  name: 'ProductCardHeader',
  mixins: [productIdMappingMixin],
  props: {
    productId: {
      type: Number, required: true
    },
    title: {
      type: String, default: ''
    }
  },
  computed: {
    ...mapState(['agency']),
    ...mapGetters(['getProductById']),
    product () {
      return this.getProductById(this.productId);
    },
    productDescription () {
      if (this.getProductId('eSignature') === this.product.productId) {
        return '(powered by Formstack Sign)';
      }
      return '';
    }
  },
  mounted: async function () {
    if ((this.agency || null) === null) {
      var response = await this.$api.getAgency();
      if (response.code !== 0) {
        this.setError({ errorMessage: `Error - Unable to get agency information. Message: ${response.message}` });
        return;
      }
      this.setAgency(JSON.parse(response.data[0]));
    }
  },
  methods: {
    ...mapActions(['setError', 'setAgency'])
  }
};

</script>
